import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { getSolution_newton } from '../actions';


class FormularioNewton extends React.Component {
    
    renderError({ error, touched }){
        
        if (touched && error){
            
            return(
                <div className="ui error message">
                    <p>
                        {error}
                    </p>
                </div>
            );
        }
        
    }
    
    renderInput = (formProps) =>{
        const className = `field ${formProps.meta.error && formProps.meta.touched ? 'error':''}`;
        return(
          <div className={className}>
            <label>{formProps.label}</label>
            <input type="text" {...formProps.input} autoComplete="off"/>
            {this.renderError(formProps.meta)}
          </div>        
        );
    }

    onInputSubmit = (formValues) =>{

        this.props.getSolution_newton(formValues);
    }
    
    render(){
        return(
            <form className="ui form error" onSubmit={this.props.handleSubmit(this.onInputSubmit)}>
                <Field name="funcion" component={this.renderInput} label="Function"/>
                <Field name="rango_a" component={this.renderInput} label="Range [a"/>
                <Field name="rango_b" component={this.renderInput} label="Range b]"/>
                <Field name="punto" component={this.renderInput} label="Initial point"/>
                <Field name="iteraciones" component={this.renderInput} label="Number of iterations"/>
                <button className="ui button primary" type="submit" >Enter</button>
            </form>
        )
        
    }
}

const validate = (formValues) => {
    const errors = {};

    // Whitelist: only allow digits, 'x', math operators, spaces and decimal point
    const FUNC_WHITELIST = /^[0-9x\s\+\-\*\/\^\.()\.]+$/;
    const NUM_WHITELIST  = /^-?[0-9]+(\.[0-9]+)?$/;
    const INT_WHITELIST  = /^[0-9]+$/;

    if (!formValues.funcion) {
        errors.funcion = 'Must enter a single variable function!';
    } else if (!FUNC_WHITELIST.test(formValues.funcion)) {
        errors.funcion = "Invalid function! Use ONLY 'x', numbers and operators: + - * / ^";
    } else if (formValues.funcion.indexOf('**') > -1) {
        errors.funcion = 'Use ^ for powering the variable';
    }

    if (!formValues.rango_a) {
        errors.rango_a = 'Must enter range a!';
    } else if (!NUM_WHITELIST.test(formValues.rango_a.trim())) {
        errors.rango_a = 'Must enter only numbers';
    }

    if (!formValues.rango_b) {
        errors.rango_b = 'Must enter range b!';
    } else if (!NUM_WHITELIST.test(formValues.rango_b.trim())) {
        errors.rango_b = 'Must enter only numbers';
    }

    if (!formValues.iteraciones) {
        errors.iteraciones = 'Must enter number of iterations as stopping criteria!';
    } else if (!INT_WHITELIST.test(formValues.iteraciones.trim())) {
        errors.iteraciones = 'Must enter only numbers';
    } else if (parseInt(formValues.iteraciones) > 20 || parseInt(formValues.iteraciones) < 1) {
        errors.iteraciones = 'Enter from 1 to 20 iterations!';
    }

    if (formValues.rango_a && formValues.rango_b &&
        parseFloat(formValues.rango_a) > parseFloat(formValues.rango_b)) {
        errors.rango_a = 'Range a must be less than range b';
        errors.rango_b = 'Range b must be greater than range a';
    }

    return errors;
}


const formWrapped = reduxForm({
    form:'datosNewton',
    validate: validate
})(FormularioNewton);

export default connect(null,{ getSolution_newton : getSolution_newton })(formWrapped);